import { render } from "./Marshall.vue?vue&type=template&id=1d493aa8&scoped=true"
import script from "./Marshall.vue?vue&type=script&lang=js"
export * from "./Marshall.vue?vue&type=script&lang=js"

import "./Marshall.vue?vue&type=style&index=0&id=1d493aa8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d493aa8"]])

export default __exports__